export const ocean = {
  name: 'Ocean',
  color: [0.61, 0.61, 0.61, 1],
  bg: [0.23, 0.39, 0.76, 1],
  grid1: [1, 1, 1, 1],
  grid2: [0.29, 0.52, 0.96, 0.5],
}
